
import VolumeSlash from "../../../assets/filled/VolumeSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VolumeSlashIcon({ className, dataTestid = "VolumeSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VolumeSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
